export const PERMS = {
    READ: 'driver_equipments.read',
    UPDATE: 'driver_equipments.update',
    DELETE: 'driver_equipments.delete',
    CREATE: 'driver_equipments.create',
    EXPORT: 'driver_equipments.export',
}
